// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit_gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__layout___C3IYs {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  grid-gap: 18px;
  gap: 18px;
  align-items: start;
}

.styles__layoutMigration___JSmj_ {
  grid-template-columns: 220px 240px minmax(0, 1fr);
}

.styles__migrationBanner___KXsfD {
  background: #fff7e0;
  border: 1px solid #f0d995;
  border-radius: 6px;
  padding: 12px 18px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
}

.styles__migrationBannerText___a1Cgc {
  font-size: 13px;
  color: #6e530f;
  line-height: 1.45;
}

.styles__migrationBannerText___a1Cgc strong {
  color: #2a2926;
  font-weight: 700;
}

.styles__legacyRail___tttgQ {
  background: #fffaef;
  border: 1px solid #f0d995;
  border-radius: 8px;
  padding: 10px 8px;
}

.styles__legacyRailTitle___fEIbY {
  padding: 6px 10px 8px;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7a5a14;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles__legacyCount___ezmkZ {
  background: #faecbe;
  color: #7a5a14;
  padding: 2px 9px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.styles__legacyHint___odRyh {
  padding: 0 10px 8px;
  font-size: 12px;
  color: #7a5a14;
  line-height: 1.45;
}

.styles__legacyHint___odRyh strong {
  font-weight: 700;
}

.styles__queueItem___xnM37 {
  padding: 10px 12px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #f0d995;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.styles__queueItem___xnM37 + .styles__queueItem___xnM37 {
  margin-top: 6px;
}

.styles__queueItem___xnM37:hover {
  border-color: #d99e2c;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.styles__queueItemBody___xN4OT {
  min-width: 0;
}

.styles__queueName___BfsQW {
  font-size: 14px;
  font-weight: 500;
  color: #2a2926;
  word-break: break-word;
}

.styles__queueMeta___Z7WhS {
  font-size: 12px;
  color: #8d8980;
  margin-top: 2px;
}

.styles__queueItemActions___VdZJ9 {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.styles__queueBtn___NI4m2 {
  background: #ffffff;
  border: 1px solid #e6e3da;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #2a2926;
  cursor: pointer;
  font-family: inherit;
}

.styles__queueBtn___NI4m2:hover {
  background: #faf9f4;
}

.styles__queueBtnPrimary___jzwvb {
  background: #ffffff;
  border: 1px solid #b88c2f;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #7a5a14;
  cursor: pointer;
  font-family: inherit;
}

.styles__queueBtnPrimary___jzwvb:hover {
  background: #faecbe;
}

.styles__folderRail___PcoKx {
  background: #ffffff;
  border: 1px solid #e6e3da;
  border-radius: 8px;
  padding: 10px 8px;
}

.styles__folderRailFlat___wSW87 {
  background: #ffffff;
  padding: 10px 8px;
}

.styles__railTitle___JFwWl {
  padding: 6px 10px 10px;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8d8980;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles__folder___fQwJh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-radius: 5px;
  font-size: 14px;
  color: #44423e;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.styles__folder___fQwJh:hover {
  background: #faf9f4;
}

.styles__folderActive___aiU1l {
  background: #e7eef6;
  color: #21436d;
  font-weight: 700;
}

.styles__folderActive___aiU1l:hover {
  background: #e7eef6;
}

.styles__folderActive___aiU1l .styles__count___QiK2_ {
  color: #5076a3;
}

.styles__folderActive___aiU1l .styles__chev___QJTd3 {
  color: #21436d;
}

.styles__folderLabel___gDqZb {
  display: flex;
  align-items: center;
  min-width: 0;
}

.styles__count___QiK2_ {
  font-size: 12px;
  color: #9c9890;
  flex-shrink: 0;
  margin-left: 8px;
}

.styles__chev___QJTd3 {
  color: #b8b4ac;
  margin-right: 8px;
  font-size: 10px;
  width: 8px;
  display: inline-block;
  text-align: center;
}

.styles__chevSpacer___IyiYC {
  width: 8px;
  margin-right: 8px;
  display: inline-block;
}

.styles__indent___l0F3Y {
  padding-left: 36px;
}

.styles__indent2___MkXes {
  padding-left: 60px;
}

.styles__mainCard___mGaJz {
  background: #ffffff;
  border: 1px solid #e6e3da;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  min-height: 480px;
}

.styles__mainCardFlat___HJ5n6 {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  min-height: 480px;
}

.styles__mainCardHeader___H2o7K {
  padding: 20px 22px 14px;
  border-bottom: 1px solid #f0eee6;
}

.styles__breadcrumb___cWa3B {
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8d8980;
  font-weight: 700;
  margin-bottom: 6px;
}

.styles__mainCardTitle___KAtUW {
  font-size: 26px;
  font-weight: 800;
  color: #2a2926;
  line-height: 1.15;
  letter-spacing: -0.01em;
}

.styles__mainCardSubtitle___wrmvM {
  font-size: 13px;
  color: #6b6962;
  margin-top: 8px;
}

.styles__fileList____FdNW {
  padding: 16px 0 8px;
}

.styles__fileCard___CJn54 {
  margin: 0 22px 12px;
}

.styles__fileCardHeader___tQ90c {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.styles__fileCardTitleBlock___c4aeP {
  flex: 1 1 auto;
  min-width: 200px;
}

.styles__fileCardTitle___RFLPU {
  font-size: 16px;
  font-weight: 700;
  color: #2a2926;
}

.styles__fileCardSubtitle___VZj75 {
  font-size: 13px;
  color: #8d8980;
  margin-top: 4px;
}

.styles__fileCardActions___QJvDr {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.styles__fileCardInset___FFQ1L {
  border: 1px solid #f0eee6;
  border-radius: 8px;
  padding: 14px 16px;
  background: #fcfbf6;
}

.styles__metaRow___zv0WQ {
  font-size: 14px;
  color: #2a2926;
  line-height: 1.7;
}

.styles__metaRow___zv0WQ strong {
  font-weight: 700;
}

.styles__emptyState___MHvvD {
  padding: 36px 22px;
  text-align: center;
  color: #8d8980;
  font-size: 13px;
}

.styles__placeholder___syvh6 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 22px;
  text-align: center;
  color: #8d8980;
  font-size: 15px;
}

.styles__uploadBlock___ZP_9e {
  margin: 4px 22px 22px;
}

.styles__uploadLabel___EwMJL {
  font-size: 15px;
  font-weight: 600;
  color: #5a564e;
  margin-bottom: 10px;
}

.styles__dropzone___VpSiP {
  border: 1.5px dashed #c9c4b6;
  border-radius: 8px;
  background: #fcfbf6;
  padding: 32px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.styles__dropzone___VpSiP:hover,
.styles__dropzoneActive___ljt5z {
  border-color: #4d8466;
  background: #ecf3ee;
}

.styles__dropzoneIcon___Lw3BM {
  color: #b8b4ac;
  flex-shrink: 0;
}

.styles__dropzoneText___i93RL {
  color: #8d8980;
  font-size: 17px;
}

.styles__hiddenInput___xNnYw {
  display: none;
}

.styles__uploadFilenameRow___uVOmb {
  margin-top: 14px;
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.styles__uploadFilename___zEzzK {
  flex: 1;
  border: 1px solid #d6d2c6;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 14px;
  color: #2a2926;
  background: #ffffff;
  font-family: inherit;
}

.styles__uploadFilename___zEzzK:focus {
  outline: none;
  border-color: #4d8466;
  box-shadow: 0 0 0 3px rgba(77, 132, 102, 0.12);
}

.styles__uploadSubmit___vgyJu {
  border: 1px solid #d6d2c6;
  background: #ffffff;
  color: #2a2926;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
}

.styles__uploadSubmit___vgyJu:hover:not(:disabled) {
  background: #f7f6f1;
}

.styles__uploadSubmit___vgyJu:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.styles__archivedBlock___Uo2vy {
  margin: 0 22px 22px;
  border-top: 1px solid #e6e3da;
  padding-top: 14px;
}

.styles__archivedHeader___lThRM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  color: #5a564e;
  font-size: 14px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}

.styles__archivedHeader___lThRM:hover {
  background: #f7f6f1;
}

.styles__archivedLabel___mJU2h {
  display: flex;
  align-items: center;
}

.styles__archivedLabel___mJU2h .styles__chev___QJTd3 {
  color: #b8b4ac;
  margin-right: 8px;
  font-size: 10px;
  width: 8px;
  display: inline-block;
}

.styles__archivedCount___Emra0 {
  font-size: 12px;
  color: #9c9890;
  font-weight: 500;
}

.styles__archivedList___uYmnJ {
  margin-top: 8px;
}

.styles__archivedEmpty___tNuoX {
  padding: 14px 12px;
  color: #8d8980;
  font-size: 13px;
}

.styles__moveOverlay___iB_2O {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles__moveBackdrop___RIUxM {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.styles__moveCard___k9Jzw {
  position: relative;
  z-index: 1;
  width: 520px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 80px);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.styles__moveHeader___GCx3F {
  padding: 20px 22px 14px;
  border-bottom: 1px solid #f0eee6;
}

.styles__moveTitle___zjtBE {
  font-size: 18px;
  font-weight: 700;
  color: #2a2926;
}

.styles__moveSubtitle___PiI8K {
  font-size: 14px;
  color: #2a2926;
  margin-top: 4px;
  word-break: break-all;
}

.styles__moveCurrent___UEtKp {
  font-size: 12px;
  color: #8d8980;
  margin-top: 8px;
}

.styles__moveLegacyCaption___cSrkw {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #faecbe;
  color: #7a5a14;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.styles__moveBody___m_KwQ {
  padding: 14px 22px 18px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.styles__moveBodyLabel___nHqya {
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8d8980;
  font-weight: 700;
  margin-bottom: 8px;
}

.styles__moveFooter___s6Wx5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 22px;
  border-top: 1px solid #f0eee6;
  background: #faf9f4;
}

.styles__moveFooterLeft___lUrMk {
  display: flex;
}

.styles__moveFooterRight___rJwDd {
  display: flex;
  gap: 10px;
}

.styles__moveArchive___MinCs {
  border: 1px solid #c0392b;
  background: #ffffff;
  color: #c0392b;
  border-radius: 6px;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.styles__moveArchive___MinCs:hover:not(:disabled) {
  background: #fdecea;
}

.styles__moveArchive___MinCs:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.styles__renameInput___MVPQK {
  width: 100%;
}

.styles__renameBtn___pNJ3O {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin-left: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 13px;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  vertical-align: middle;
  flex-shrink: 0;
}

.styles__renameBtn___pNJ3O:hover {
  opacity: 0.7;
}

.styles__moveCancel___ZekOS {
  border: 1px solid #d6d2c6;
  background: #ffffff;
  color: #2a2926;
  border-radius: 6px;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
}

.styles__moveCancel___ZekOS:hover:not(:disabled) {
  background: #f7f6f1;
}

.styles__moveCancel___ZekOS:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.styles__moveConfirm___YcCvv {
  border: 1px solid #4d8466;
  background: #4d8466;
  color: #ffffff;
  border-radius: 6px;
  padding: 8px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.styles__moveConfirm___YcCvv:hover:not(:disabled) {
  background: #426d54;
  border-color: #426d54;
}

.styles__moveConfirm___YcCvv:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.styles__pickerTree___gZjpv {
  border: 1px solid #e6e3da;
  border-radius: 8px;
  padding: 8px 6px;
  max-height: 320px;
  overflow-y: auto;
}

.styles__pickerBranch___p5KN6 {
  color: #6b6962;
  cursor: pointer;
}

.styles__pickerLeaf___yBmPm {
  cursor: pointer;
}

.styles__pickerCurrent___eBvHv {
  cursor: not-allowed;
  color: #b8b4ac;
  background: transparent !important;
}

.styles__pickerCurrentTag___WqqF1 {
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #b8b4ac;
  flex-shrink: 0;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Main/DigitalFile/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAS;EAAT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAQ;EAAR,QAAQ;EAAR,SAAQ;EAAR,OAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAQ;EAAR,QAAQ;EAAR,SAAQ;EAAR,OAAQ;EACR,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yDAAsD;EACtD,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".layout {\n  display: grid;\n  grid-template-columns: 240px minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.layoutMigration {\n  grid-template-columns: 220px 240px minmax(0, 1fr);\n}\n\n.migrationBanner {\n  background: #fff7e0;\n  border: 1px solid #f0d995;\n  border-radius: 6px;\n  padding: 12px 18px;\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 18px;\n}\n\n.migrationBannerText {\n  font-size: 13px;\n  color: #6e530f;\n  line-height: 1.45;\n}\n\n.migrationBannerText strong {\n  color: #2a2926;\n  font-weight: 700;\n}\n\n.legacyRail {\n  background: #fffaef;\n  border: 1px solid #f0d995;\n  border-radius: 8px;\n  padding: 10px 8px;\n}\n\n.legacyRailTitle {\n  padding: 6px 10px 8px;\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #7a5a14;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.legacyCount {\n  background: #faecbe;\n  color: #7a5a14;\n  padding: 2px 9px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.legacyHint {\n  padding: 0 10px 8px;\n  font-size: 12px;\n  color: #7a5a14;\n  line-height: 1.45;\n}\n\n.legacyHint strong {\n  font-weight: 700;\n}\n\n.queueItem {\n  padding: 10px 12px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #ffffff;\n  border: 1px solid #f0d995;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.queueItem + .queueItem {\n  margin-top: 6px;\n}\n\n.queueItem:hover {\n  border-color: #d99e2c;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.queueItemBody {\n  min-width: 0;\n}\n\n.queueName {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2a2926;\n  word-break: break-word;\n}\n\n.queueMeta {\n  font-size: 12px;\n  color: #8d8980;\n  margin-top: 2px;\n}\n\n.queueItemActions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.queueBtn {\n  background: #ffffff;\n  border: 1px solid #e6e3da;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #2a2926;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.queueBtn:hover {\n  background: #faf9f4;\n}\n\n.queueBtnPrimary {\n  background: #ffffff;\n  border: 1px solid #b88c2f;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #7a5a14;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.queueBtnPrimary:hover {\n  background: #faecbe;\n}\n\n.folderRail {\n  background: #ffffff;\n  border: 1px solid #e6e3da;\n  border-radius: 8px;\n  padding: 10px 8px;\n}\n\n.folderRailFlat {\n  background: #ffffff;\n  padding: 10px 8px;\n}\n\n.railTitle {\n  padding: 6px 10px 10px;\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8d8980;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.folder {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 5px;\n  font-size: 14px;\n  color: #44423e;\n  cursor: pointer;\n  user-select: none;\n}\n\n.folder:hover {\n  background: #faf9f4;\n}\n\n.folderActive {\n  background: #e7eef6;\n  color: #21436d;\n  font-weight: 700;\n}\n\n.folderActive:hover {\n  background: #e7eef6;\n}\n\n.folderActive .count {\n  color: #5076a3;\n}\n\n.folderActive .chev {\n  color: #21436d;\n}\n\n.folderLabel {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.count {\n  font-size: 12px;\n  color: #9c9890;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.chev {\n  color: #b8b4ac;\n  margin-right: 8px;\n  font-size: 10px;\n  width: 8px;\n  display: inline-block;\n  text-align: center;\n}\n\n.chevSpacer {\n  width: 8px;\n  margin-right: 8px;\n  display: inline-block;\n}\n\n.indent {\n  padding-left: 36px;\n}\n\n.indent2 {\n  padding-left: 60px;\n}\n\n.mainCard {\n  background: #ffffff;\n  border: 1px solid #e6e3da;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  min-height: 480px;\n}\n\n.mainCardFlat {\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  min-height: 480px;\n}\n\n.mainCardHeader {\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid #f0eee6;\n}\n\n.breadcrumb {\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8d8980;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.mainCardTitle {\n  font-size: 26px;\n  font-weight: 800;\n  color: #2a2926;\n  line-height: 1.15;\n  letter-spacing: -0.01em;\n}\n\n.mainCardSubtitle {\n  font-size: 13px;\n  color: #6b6962;\n  margin-top: 8px;\n}\n\n.fileList {\n  padding: 16px 0 8px;\n}\n\n.fileCard {\n  margin: 0 22px 12px;\n}\n\n.fileCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n.fileCardTitleBlock {\n  flex: 1 1 auto;\n  min-width: 200px;\n}\n\n.fileCardTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: #2a2926;\n}\n\n.fileCardSubtitle {\n  font-size: 13px;\n  color: #8d8980;\n  margin-top: 4px;\n}\n\n.fileCardActions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.fileCardInset {\n  border: 1px solid #f0eee6;\n  border-radius: 8px;\n  padding: 14px 16px;\n  background: #fcfbf6;\n}\n\n.metaRow {\n  font-size: 14px;\n  color: #2a2926;\n  line-height: 1.7;\n}\n\n.metaRow strong {\n  font-weight: 700;\n}\n\n.emptyState {\n  padding: 36px 22px;\n  text-align: center;\n  color: #8d8980;\n  font-size: 13px;\n}\n\n.placeholder {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 22px;\n  text-align: center;\n  color: #8d8980;\n  font-size: 15px;\n}\n\n.uploadBlock {\n  margin: 4px 22px 22px;\n}\n\n.uploadLabel {\n  font-size: 15px;\n  font-weight: 600;\n  color: #5a564e;\n  margin-bottom: 10px;\n}\n\n.dropzone {\n  border: 1.5px dashed #c9c4b6;\n  border-radius: 8px;\n  background: #fcfbf6;\n  padding: 32px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.dropzone:hover,\n.dropzoneActive {\n  border-color: #4d8466;\n  background: #ecf3ee;\n}\n\n.dropzoneIcon {\n  color: #b8b4ac;\n  flex-shrink: 0;\n}\n\n.dropzoneText {\n  color: #8d8980;\n  font-size: 17px;\n}\n\n.hiddenInput {\n  display: none;\n}\n\n.uploadFilenameRow {\n  margin-top: 14px;\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.uploadFilename {\n  flex: 1;\n  border: 1px solid #d6d2c6;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #2a2926;\n  background: #ffffff;\n  font-family: inherit;\n}\n\n.uploadFilename:focus {\n  outline: none;\n  border-color: #4d8466;\n  box-shadow: 0 0 0 3px rgba(77, 132, 102, 0.12);\n}\n\n.uploadSubmit {\n  border: 1px solid #d6d2c6;\n  background: #ffffff;\n  color: #2a2926;\n  border-radius: 6px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.uploadSubmit:hover:not(:disabled) {\n  background: #f7f6f1;\n}\n\n.uploadSubmit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.archivedBlock {\n  margin: 0 22px 22px;\n  border-top: 1px solid #e6e3da;\n  padding-top: 14px;\n}\n\n.archivedHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #5a564e;\n  font-size: 14px;\n  font-weight: 600;\n  user-select: none;\n}\n\n.archivedHeader:hover {\n  background: #f7f6f1;\n}\n\n.archivedLabel {\n  display: flex;\n  align-items: center;\n}\n\n.archivedLabel .chev {\n  color: #b8b4ac;\n  margin-right: 8px;\n  font-size: 10px;\n  width: 8px;\n  display: inline-block;\n}\n\n.archivedCount {\n  font-size: 12px;\n  color: #9c9890;\n  font-weight: 500;\n}\n\n.archivedList {\n  margin-top: 8px;\n}\n\n.archivedEmpty {\n  padding: 14px 12px;\n  color: #8d8980;\n  font-size: 13px;\n}\n\n.moveOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.moveBackdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: pointer;\n}\n\n.moveCard {\n  position: relative;\n  z-index: 1;\n  width: 520px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 80px);\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.moveHeader {\n  padding: 20px 22px 14px;\n  border-bottom: 1px solid #f0eee6;\n}\n\n.moveTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #2a2926;\n}\n\n.moveSubtitle {\n  font-size: 14px;\n  color: #2a2926;\n  margin-top: 4px;\n  word-break: break-all;\n}\n\n.moveCurrent {\n  font-size: 12px;\n  color: #8d8980;\n  margin-top: 8px;\n}\n\n.moveLegacyCaption {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 10px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #faecbe;\n  color: #7a5a14;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.moveBody {\n  padding: 14px 22px 18px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.moveBodyLabel {\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8d8980;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.moveFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 22px;\n  border-top: 1px solid #f0eee6;\n  background: #faf9f4;\n}\n\n.moveFooterLeft {\n  display: flex;\n}\n\n.moveFooterRight {\n  display: flex;\n  gap: 10px;\n}\n\n.moveArchive {\n  border: 1px solid #c0392b;\n  background: #ffffff;\n  color: #c0392b;\n  border-radius: 6px;\n  padding: 8px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.moveArchive:hover:not(:disabled) {\n  background: #fdecea;\n}\n\n.moveArchive:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.renameInput {\n  composes: uploadFilename;\n  width: 100%;\n}\n\n.renameBtn {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  margin-left: 8px;\n  background-image: url('styles/img/icon_edit_gray.png');\n  background-size: 13px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  flex-shrink: 0;\n}\n\n.renameBtn:hover {\n  opacity: 0.7;\n}\n\n.moveCancel {\n  border: 1px solid #d6d2c6;\n  background: #ffffff;\n  color: #2a2926;\n  border-radius: 6px;\n  padding: 8px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.moveCancel:hover:not(:disabled) {\n  background: #f7f6f1;\n}\n\n.moveCancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.moveConfirm {\n  border: 1px solid #4d8466;\n  background: #4d8466;\n  color: #ffffff;\n  border-radius: 6px;\n  padding: 8px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.moveConfirm:hover:not(:disabled) {\n  background: #426d54;\n  border-color: #426d54;\n}\n\n.moveConfirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pickerTree {\n  border: 1px solid #e6e3da;\n  border-radius: 8px;\n  padding: 8px 6px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.pickerBranch {\n  color: #6b6962;\n  cursor: pointer;\n}\n\n.pickerLeaf {\n  cursor: pointer;\n}\n\n.pickerCurrent {\n  cursor: not-allowed;\n  color: #b8b4ac;\n  background: transparent !important;\n}\n\n.pickerCurrentTag {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #b8b4ac;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `styles__layout___C3IYs`,
	"layoutMigration": `styles__layoutMigration___JSmj_`,
	"migrationBanner": `styles__migrationBanner___KXsfD`,
	"migrationBannerText": `styles__migrationBannerText___a1Cgc`,
	"legacyRail": `styles__legacyRail___tttgQ`,
	"legacyRailTitle": `styles__legacyRailTitle___fEIbY`,
	"legacyCount": `styles__legacyCount___ezmkZ`,
	"legacyHint": `styles__legacyHint___odRyh`,
	"queueItem": `styles__queueItem___xnM37`,
	"queueItemBody": `styles__queueItemBody___xN4OT`,
	"queueName": `styles__queueName___BfsQW`,
	"queueMeta": `styles__queueMeta___Z7WhS`,
	"queueItemActions": `styles__queueItemActions___VdZJ9`,
	"queueBtn": `styles__queueBtn___NI4m2`,
	"queueBtnPrimary": `styles__queueBtnPrimary___jzwvb`,
	"folderRail": `styles__folderRail___PcoKx`,
	"folderRailFlat": `styles__folderRailFlat___wSW87`,
	"railTitle": `styles__railTitle___JFwWl`,
	"folder": `styles__folder___fQwJh`,
	"folderActive": `styles__folderActive___aiU1l`,
	"count": `styles__count___QiK2_`,
	"chev": `styles__chev___QJTd3`,
	"folderLabel": `styles__folderLabel___gDqZb`,
	"chevSpacer": `styles__chevSpacer___IyiYC`,
	"indent": `styles__indent___l0F3Y`,
	"indent2": `styles__indent2___MkXes`,
	"mainCard": `styles__mainCard___mGaJz`,
	"mainCardFlat": `styles__mainCardFlat___HJ5n6`,
	"mainCardHeader": `styles__mainCardHeader___H2o7K`,
	"breadcrumb": `styles__breadcrumb___cWa3B`,
	"mainCardTitle": `styles__mainCardTitle___KAtUW`,
	"mainCardSubtitle": `styles__mainCardSubtitle___wrmvM`,
	"fileList": `styles__fileList____FdNW`,
	"fileCard": `styles__fileCard___CJn54`,
	"fileCardHeader": `styles__fileCardHeader___tQ90c`,
	"fileCardTitleBlock": `styles__fileCardTitleBlock___c4aeP`,
	"fileCardTitle": `styles__fileCardTitle___RFLPU`,
	"fileCardSubtitle": `styles__fileCardSubtitle___VZj75`,
	"fileCardActions": `styles__fileCardActions___QJvDr`,
	"fileCardInset": `styles__fileCardInset___FFQ1L`,
	"metaRow": `styles__metaRow___zv0WQ`,
	"emptyState": `styles__emptyState___MHvvD`,
	"placeholder": `styles__placeholder___syvh6`,
	"uploadBlock": `styles__uploadBlock___ZP_9e`,
	"uploadLabel": `styles__uploadLabel___EwMJL`,
	"dropzone": `styles__dropzone___VpSiP`,
	"dropzoneActive": `styles__dropzoneActive___ljt5z`,
	"dropzoneIcon": `styles__dropzoneIcon___Lw3BM`,
	"dropzoneText": `styles__dropzoneText___i93RL`,
	"hiddenInput": `styles__hiddenInput___xNnYw`,
	"uploadFilenameRow": `styles__uploadFilenameRow___uVOmb`,
	"uploadFilename": `styles__uploadFilename___zEzzK`,
	"uploadSubmit": `styles__uploadSubmit___vgyJu`,
	"archivedBlock": `styles__archivedBlock___Uo2vy`,
	"archivedHeader": `styles__archivedHeader___lThRM`,
	"archivedLabel": `styles__archivedLabel___mJU2h`,
	"archivedCount": `styles__archivedCount___Emra0`,
	"archivedList": `styles__archivedList___uYmnJ`,
	"archivedEmpty": `styles__archivedEmpty___tNuoX`,
	"moveOverlay": `styles__moveOverlay___iB_2O`,
	"moveBackdrop": `styles__moveBackdrop___RIUxM`,
	"moveCard": `styles__moveCard___k9Jzw`,
	"moveHeader": `styles__moveHeader___GCx3F`,
	"moveTitle": `styles__moveTitle___zjtBE`,
	"moveSubtitle": `styles__moveSubtitle___PiI8K`,
	"moveCurrent": `styles__moveCurrent___UEtKp`,
	"moveLegacyCaption": `styles__moveLegacyCaption___cSrkw`,
	"moveBody": `styles__moveBody___m_KwQ`,
	"moveBodyLabel": `styles__moveBodyLabel___nHqya`,
	"moveFooter": `styles__moveFooter___s6Wx5`,
	"moveFooterLeft": `styles__moveFooterLeft___lUrMk`,
	"moveFooterRight": `styles__moveFooterRight___rJwDd`,
	"moveArchive": `styles__moveArchive___MinCs`,
	"renameInput": `styles__renameInput___MVPQK styles__uploadFilename___zEzzK`,
	"renameBtn": `styles__renameBtn___pNJ3O`,
	"moveCancel": `styles__moveCancel___ZekOS`,
	"moveConfirm": `styles__moveConfirm___YcCvv`,
	"pickerTree": `styles__pickerTree___gZjpv`,
	"pickerBranch": `styles__pickerBranch___p5KN6`,
	"pickerLeaf": `styles__pickerLeaf___yBmPm`,
	"pickerCurrent": `styles__pickerCurrent___eBvHv`,
	"pickerCurrentTag": `styles__pickerCurrentTag___WqqF1`
};
export default ___CSS_LOADER_EXPORT___;
